import { SettingsComponent } from "@/features/esoPerson/settings"

export const SettingsPage = () => {
  return <SettingsComponent />
}
